
import PropTypes from 'prop-types'

import MenuV5 from '@mui/material/Menu'
import { MenuItemView } from './popover/MenuItemView'

import { constants as fromRequestReliefVehicles } from 'features/request-relief-vehicles'
import { constants as fromRequestVehicleRelocations } from 'features/request-vehicle-relocations'
import { constants as fromRequestContractVariations } from 'features/request-contract-variations'
import { constants as fromRequestVehicleSummary } from 'features/request-vehicle-summary'
import { constants as fromRequestRucSummary } from 'features/request-ruc-summary'

import { useLocation } from 'react-router-dom'
import { useHasRucAccess } from 'features/settings'

const ActionsPopover = ({
  anchor,
  linker,
  open,
  onClose
}) => {
  const location = useLocation()
  const hasRucAccess = useHasRucAccess()

  const MenuList = [
    {
      title: 'Relief/Rental Vehicle Booking Summary',
      path: fromRequestReliefVehicles.PATH_ALL,
      visible: true,
    },
    {
      title: 'Vehicle Relocations Summary',
      path: fromRequestVehicleRelocations.PATH_ALL,
      visible: true,
    },
    {
      title: 'Contract Variations Summary',
      path: fromRequestContractVariations.PATH_ALL,
      visible: true,
    },
    {
      title: 'Vehicle Order Summary',
      path: fromRequestVehicleSummary.PATH_ALL,
      visible: true,
    },
    {
      title: 'RUC Requests Summary',
      path: fromRequestRucSummary.PATH_ALL,
      visible: hasRucAccess,
    },
  ]

  if ( ! anchor.current) {
    return null
  }

  return (
    <MenuV5
      id="menu-reports"
      anchorEl={anchor.current}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            '& ul': {
              padding: 0,
            }
          }
        },
      }}>
      <div>
        {MenuList?.map((menuListItem) => {
          if (menuListItem.path === fromRequestVehicleSummary.PATH_ALL) {
            return (
              <MenuItemView
                key={menuListItem?.title}
                title={menuListItem?.title}
                onClick={linker(menuListItem?.path)}
                isActive={menuListItem?.path === location.pathname}
                isVisible={menuListItem?.visible}/>
            )
          }

          return (
            <MenuItemView
              key={menuListItem?.title}
              title={menuListItem?.title}
              onClick={linker(menuListItem?.path)}
              isActive={menuListItem?.path === location.pathname}
              isVisible={menuListItem?.visible}/>
          )
        })}
      </div>
    </MenuV5>
  )
}

ActionsPopover.propTypes = {
  anchor: PropTypes.object,
  linker: PropTypes.func.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

export default ActionsPopover
